<div class="bk-login__container">
	<div class="bk-login">
		<div class="bk-login__welcome-box">
			<h4>Confirm Email</h4>
			<p>Thank you for confirming your email. Please <a routerLink='/login'>Click here to log in</a></p>
		</div>
	</div>
</div>